import { Gamepad2 } from 'lucide-react';
import { DivisionPage } from '../components/DivisionPage';
import { VideoCarousel } from '../components/VideoCarousel';
import { CTASection } from '../components/CTASection';

export function GameDevPage() {
  return (
    <DivisionPage
      accent="accent-game"
      icon={Gamepad2}
      nameKey="game.name"
      badgeKey="game.badge"
      titleKey="game.heroTitle"
      leadKey="game.heroLead"
      pitchKey="game.pitch"
      underTitle={<VideoCarousel />}
      features={[
        { titleKey: 'game.s1t', descKey: 'game.s1d' },
        { titleKey: 'game.s2t', descKey: 'game.s2d' },
        { titleKey: 'game.s3t', descKey: 'game.s3d' },
        { titleKey: 'game.s4t', descKey: 'game.s4d' },
        { titleKey: 'game.s5t', descKey: 'game.s5d' },
      ]}
    >
      <CTASection />
    </DivisionPage>
  );
}

